import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-playerpage',
  templateUrl: './playerpage.component.html',
  styleUrls: ['./playerpage.component.css']
})
export class PlayerpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
